import { render, staticRenderFns } from "./LicenseInfo.vue?vue&type=template&id=3b5b3630&scoped=true"
import script from "./LicenseInfo.vue?vue&type=script&lang=js"
export * from "./LicenseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b3630",
  null
  
)

export default component.exports